import React, { FC, memo } from "react";
import { useTranslation } from "react-i18next";

import { Text } from "@/components/Text";
import { IConsultantProfile } from "@/data/consultant-profiles";
import { formatFullName } from "@/data/persons";
import { Flex } from "@/eworkitComponents/components";
import { List, ListItem } from "@/views/components/List";

export interface AssignmentRelatedConsultantsListProps {
  consultantProfile: IConsultantProfile;
  onRowClick?: (consultantProfile: IConsultantProfile) => void;
}

export const AssignmentRelatedConsultantsList: FC<AssignmentRelatedConsultantsListProps> = memo(
  ({ consultantProfile, onRowClick }) => {
    const { t } = useTranslation("session");

    return (
      <List innerShadows={false}>
        <ListItem onClick={() => onRowClick?.(consultantProfile)}>
          <Flex direction="column" innerMargin="xs">
            <Flex innerMargin="sm">
              <Flex width={6}>
                <Text color="grey2">{t("ASSIGNMENTS.DETAILS.RELATED_DETAILS.CONSULTANTS.NAME_TABLE_HEADER")}</Text>
              </Flex>

              <Flex width={6}>{formatFullName(consultantProfile)}</Flex>
            </Flex>

            <Flex innerMargin="sm">
              <Flex width={6}>
                <Text color="grey2">{t("ASSIGNMENTS.DETAILS.RELATED_DETAILS.CONSULTANTS.EMAIL_TABLE_HEADER")}</Text>
              </Flex>

              <Flex width={6}>
                <Text wordBreak="word" whiteSpace="pre-wrap">
                  {consultantProfile.email}
                </Text>
              </Flex>
            </Flex>
          </Flex>
        </ListItem>
      </List>
    );
  },
);
